export default "__VITE_ASSET__DVTDSdHp__"